













import { Prop, Component, Vue } from "vue-property-decorator";
import SelectOption from "@/common/ui/presenters/select-option";
import ScheduleCalendarSearchOptions from "@/schedule/usecases/schedule-calendar-search-options";

@Component({})
export default class ScheduleCalendarSearchBar extends Vue {
  @Prop({ required: true }) options!: ScheduleCalendarSearchOptions;
  @Prop({ default: () => [] }) roleOptions!: SelectOption[];

  submit() {
    this.$emit("submit", this.options);
  }
}
